export const tempDropdownData = [
  {
    inPerson: null,
    virtual: {
      zoomLink: "https://zoom.us/j/93837263648473?pwd=PWD39N82JK45LMO12",
      meetingId: "867 5309 890",
      meetingPasscode: "12345",
    },
    checkIn: {
      isEnabled: false,
      autoEnabled: true,
      minutesBefore: 15,
    },
    _id: "62d5d19e0243f51eb6a8aee9",
    meetingType: "MT",
    dates: [
      {
        startsOn: "2022-06-08T05:00:00.000Z",
        endsOn: "2022-06-08T10:00:00.000Z",
        timeZone: "America/Los_Angeles",
        _id: "63404543bfe2223dfdc3b437",
      },
      {
        startsOn: "2022-06-10T05:00:00.000Z",
        endsOn: "2022-06-10T10:00:00.000Z",
        timeZone: "America/Los_Angeles",
        _id: "63404543bfe2223dfdc3b438",
      },
    ],
    endMeeting: true,
    deliveryType: ["Virtual"],
    attendees: [
      {
        _id: "62d5c66c0243f51eb6a8ae8f",
        photoUrl:
          "https://stmanagementteamdev.blob.core.windows.net/photos/glen-baker.png",
        name: "Glen Baker",
      },
    ],
    admins: [
      {
        _id: "62ec3a0d8d12c3bc6d221792",
        name: "Doug Reichel",
        viewing: "Dashboard",
      },
    ],
    guests: [],
    agenda: [
      {
        owner: {
          _id: "62d5c66c0243f51eb6a8ae8f",
          name: "Glen Baker",
        },
        decision: {
          requiresQuorum: true,
          isBlockA: true,
          isBlockB: true,
          isMultipleChoice: false,
          choices: [
            {
              _id: "631659e1ccfbfcecb2da23c1",
              description: "YES",
              votes: [
                {
                  _id: "62d5c66c0243f51eb6a8ae8f",
                  name: "Glen Baker",
                  photoUrl:
                    "https://stmanagementteamdev.blob.core.windows.net/photos/glen-baker.png",
                  votedAs: "EC",
                  votedOn: "2022-01-01T00:00:00.000Z",
                },
              ],
            },
          ],
          status: "Off",
          displayResults: true,
        },
        file: [
          {
            type: "pdf",
            src: "3369d227-3773-49d2-b18b-b4ab097c4fe7",
          },
        ],
        publishedOn: "2021-12-01T00:00:00.000Z",
        title: "Huge Raise for Jeff Scott",
        description:
          "<ul><li>Greatest Employee Ever</li><li>Most handsome employee ever</li></ul>",
        notes: [
          {
            postedBy: {
              _id: "62ec3a0d8d12c3bc6d221791",
              name: "Bret Dickey",
            },
            _id: "62ec495d8d12c3bc6d2217a2",
            submittedOn: "2022-01-01T00:00:00.000Z",
            note: "This is an example of a quick note posted by Bret Dickey.",
          },
          {
            postedBy: {
              _id: "62ec3a0d8d12c3bc6d221792",
              name: "Doug Reichel",
            },
            _id: "62ec49b68d12c3bc6d2217a4",
            submittedOn: "2022-01-01T00:00:00.000Z",
            note: "This is an example of a quick note posted by Doug Reichel",
          },
        ],
        actionItem: {
          isCreated: true,
          assignedTo: [
            {
              _id: "62ec3a0d8d12c3bc6d221791",
              name: "Bret Dickey",
              assignedOn: "2022-01-01T00:00:00.000Z",
            },
          ],
        },
        _id: "631659b9ccfbfcecb2da23c0",
        viewedBy: [],
      },
    ],
    isDraft: true,
    isComplete: false,
    order: 1,
    version: 1,
    id: "62d5d19e0243f51eb6a8aee9",
    users: [
      {
        profile: {
          firstName: "Glen",
          lastName: "Baker",
          email: "bakerg@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/glen-baker.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Triple Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae8f",
        iboNumber: 1001139,
        contactId: 131,
        accessLevel: ["EC", "MT1"],
      },
      {
        profile: {
          firstName: "Joya",
          lastName: "Baker",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/joya-baker.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae90",
        contactId: 132,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Trevor",
          lastName: "Baker",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/trevor-baker.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae91",
        iboNumber: 1714173,
        contactId: 151656,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Lexi",
          lastName: "Baker",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/lexi-baker.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae92",
        iboNumber: 1714173,
        contactId: 506194,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Terry",
          lastName: "Brown",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/terry-brown.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae93",
        iboNumber: 801306,
        contactId: 357,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Jenny",
          lastName: "Brown",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jenny-brown.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae94",
        iboNumber: 801306,
        contactId: 358,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Ty",
          lastName: "Crandell",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/ty-crandell.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae95",
        iboNumber: 5466912,
        contactId: 1100456,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Venessa",
          lastName: "Crandell",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/venessa-crandell.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae96",
        iboNumber: 5466912,
        contactId: 1374809,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Howie",
          lastName: "Danzik",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/howie-danzik.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae97",
        iboNumber: 1857166,
        contactId: 647,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Theresa",
          lastName: "Danzik",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/theresa-danzik.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae98",
        iboNumber: 1857166,
        contactId: 648,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Brad",
          lastName: "Duncan",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/brad-duncan.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Crown Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae99",
        iboNumber: 2008212,
        contactId: 753,
        accessLevel: ["EC", "MT1"],
      },
      {
        profile: {
          firstName: "Julie",
          lastName: "Duncan",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae9a",
        iboNumber: 2008212,
        contactId: 754,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Greg",
          lastName: "Duncan",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/greg-duncan.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Triple Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae9b",
        iboNumber: 2559,
        contactId: 763,
        accessLevel: ["EC", "MT1"],
      },
      {
        profile: {
          firstName: "Laurie",
          lastName: "Duncan",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae9c",
        iboNumber: 2559,
        contactId: 764,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Tracey",
          lastName: "Eaton",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/tracey-eaton.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae9d",
        iboNumber: 855482,
        contactId: 807,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Kimberly",
          lastName: "Eaton",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae9e",
        iboNumber: 855482,
        contactId: 808,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Ryder",
          lastName: "Erickson",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/ryder-erickson.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae9f",
        iboNumber: 1754,
        contactId: 1390851,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Nicole",
          lastName: "Erickson",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aea0",
        iboNumber: 1754,
        contactId: 1467116,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Kelly",
          lastName: "Ewing",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/kelly-ewing.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aea1",
        iboNumber: 1764460,
        contactId: 873,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Darci",
          lastName: "Ewing",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aea2",
        iboNumber: 1764460,
        contactId: 874,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "David",
          lastName: "Felber",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/david-felber.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aea3",
        iboNumber: 5082,
        contactId: 895,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Jaimee",
          lastName: "Felber",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aea4",
        iboNumber: 5082,
        contactId: 896,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Hal",
          lastName: "Golden",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/hal-golden.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aea5",
        iboNumber: 1000758,
        contactId: 1091,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Ann",
          lastName: "Golden",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aea6",
        iboNumber: 1000758,
        contactId: 1092,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Scott",
          lastName: "Harimoto",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/scott-harimoto.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aea7",
        iboNumber: 1788634,
        contactId: 1211,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Cris",
          lastName: "Harimoto",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aea8",
        iboNumber: 1788634,
        contactId: 1212,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Bill",
          lastName: "Hawkins",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bill-hawkins.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aea9",
        iboNumber: 7789,
        contactId: 1247,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Sandy",
          lastName: "Hawkins",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeaa",
        iboNumber: 7789,
        contactId: 1248,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Pete",
          lastName: "Herschelman",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/pete-herschelman.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeab",
        iboNumber: 2636550,
        contactId: 232870,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Rachael",
          lastName: "Herschelman",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeac",
        iboNumber: 2636550,
        contactId: 232871,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Randy",
          lastName: "Jassman",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/randy-jassman.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aead",
        iboNumber: 1478107,
        contactId: 1463,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Raye-Lynn",
          lastName: "Jassman",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/raye-lynn-jassman.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeae",
        iboNumber: 1478107,
        contactId: 1464,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Nam-Deuk",
          lastName: "Kim",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/nam-deuk-kim.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Triple Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeaf",
        iboNumber: 3463383,
        contactId: 615827,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Jungyun",
          lastName: "Lee",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeb0",
        iboNumber: 3463383,
        contactId: 615828,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Bob",
          lastName: "Kummer",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bob-kummer.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeb1",
        iboNumber: 1002340,
        contactId: 1735,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Shelly",
          lastName: "Kummer",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeb2",
        iboNumber: 1002340,
        contactId: 1736,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Matt",
          lastName: "Nguyen",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/matt-nguyen.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeb3",
        iboNumber: 5862533,
        contactId: 1276055,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Briley",
          lastName: "Nguyen",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeb4",
        iboNumber: 5862533,
        contactId: 1393812,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Ryan",
          lastName: "Olynyk",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/ryan-olynyk.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeb5",
        iboNumber: 5652827,
        contactId: 1178425,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Noella",
          lastName: "Olynyk",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeb6",
        iboNumber: 5652827,
        contactId: 1178430,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Kevin",
          lastName: "Phillips",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/kevin-phillips.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeb7",
        iboNumber: 5248349,
        contactId: 978319,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Andrea",
          lastName: "Phillips",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeb8",
        iboNumber: 5248349,
        contactId: 978319,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Jim",
          lastName: "Puryear",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jim-puryear.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Crown Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeb9",
        iboNumber: 8252,
        contactId: 2545,
        accessLevel: ["EC", "MT1"],
      },
      {
        profile: {
          firstName: "Bobbie",
          lastName: "Puryear",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeba",
        iboNumber: 8252,
        contactId: 1504865,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Leslie",
          lastName: "Rice",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/leslie-rice.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aebb",
        iboNumber: 8690,
        contactId: 3454,
        accessLevel: ["EC", "MT1"],
      },
      {
        profile: {
          firstName: "Jeff",
          lastName: "Rice",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aebc",
        iboNumber: 8690,
        contactId: 1583325,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Jon",
          lastName: "Rosario",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jon-rosario.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aebd",
        iboNumber: 3459866,
        contactId: 384516,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Jen",
          lastName: "Rosario",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jen-rosario.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aebe",
        iboNumber: 3459866,
        contactId: 1093820,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Kenny",
          lastName: "Toms",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/kenny-toms.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aebf",
        iboNumber: 4780838,
        contactId: 782667,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Ashlea",
          lastName: "Toms",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aec0",
        iboNumber: 4780838,
        contactId: 1292635,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Matt",
          lastName: "Tsuruda",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/matt-tsuruda.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Founders Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aec1",
        iboNumber: 1003132,
        contactId: 3227,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Sandee",
          lastName: "Tsuruda",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aec2",
        iboNumber: 1003132,
        contactId: 3228,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Maiko",
          lastName: "Tuitupou",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/maiko-tuitupou.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aec3",
        iboNumber: 7611208,
        contactId: 1516598,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Kulia",
          lastName: "Tuitupou",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aec4",
        iboNumber: 7611208,
        contactId: 1516599,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Dean",
          lastName: "Whalen",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/dean-whalen.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aec5",
        iboNumber: 4633816,
        contactId: 712774,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Marcie",
          lastName: "Whalen",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aec6",
        iboNumber: 4633816,
        contactId: 730273,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Shane",
          lastName: "Yadao",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/shane-yadao.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aec7",
        iboNumber: 2612016,
        contactId: 231257,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Joey",
          lastName: "Yadao",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aec8",
        iboNumber: 2612016,
        contactId: 387811,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Mandy",
          lastName: "Yamamoto",
          email: "email@gmail.com",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aec9",
        iboNumber: 3984511,
        contactId: 477783,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Dan",
          lastName: "Yuen",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/dan-yuen.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeca",
        iboNumber: 1001870,
        contactId: 3533,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Sandy",
          lastName: "Yuen",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aecb",
        iboNumber: 1001870,
        contactId: 3534,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Bret",
          lastName: "Dickey",
          email: "mbd@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221791",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Doug",
          lastName: "Reichel",
          email: "ddr@wwdb.com",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221792",
        accessLevel: ["MANAGER"],
      },
      {
        profile: {
          firstName: "Kelly",
          lastName: "Moorman",
          email: "krm@wwdb.com",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221793",
        accessLevel: ["MANAGER"],
      },
      {
        profile: {
          firstName: "Britt",
          lastName: "Scott",
          email: "bls@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/britt-scott.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221794",
        accessLevel: ["MANAGER"],
      },
      {
        profile: {
          firstName: "Jeff",
          lastName: "Scott",
          email: "jcs@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jeff-scott.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221795",
        accessLevel: ["MANAGER"],
      },
      {
        profile: {
          firstName: "Miguel",
          lastName: "Rangel",
          email: "mpr@wwdb.com",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221796",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Katelynn",
          lastName: "West",
          email: "krwest@wwdb.com",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221797",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Adam",
          lastName: "Overfelt",
          email: "ajo@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/adam-overfelt.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990cd",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Andy",
          lastName: "Wickwire",
          email: "adw@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/andy-Wickwire.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990ce",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Eliana",
          lastName: "Osburn",
          email: "emo@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/eliana-osburn.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990cf",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Eve",
          lastName: "Bratrud",
          email: "emb@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/eve-bratrud.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990d0",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Jen",
          lastName: "Howe",
          email: "jlh@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jen-howe.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990d1",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Kevin",
          lastName: "Shay",
          email: "krs@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/kevin-shay.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990d2",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Vince",
          lastName: "Peasley",
          email: "vep@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/vince-peasley.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990d3",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Yajaira",
          lastName: "Elvira",
          email: "yae@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/yajaira-elvira.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990d4",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Matt",
          lastName: "Baker",
          email: "MattB@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "632a3a3b97da849d696044ae",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "User",
          lastName: "One",
          email: "ttp@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "632a5dd797da849d696044af",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Patrick",
          lastName: "Li",
          email: "PLi@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "632bcd250922192bf1db9ad6",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Tristan",
          lastName: "Johnson",
          email: "TristanJ@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "63351bee84c8303429b38095",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Tristan",
          lastName: "Johnson",
          email: "tristanj@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "63351c1f84c8303429b38096",
        accessLevel: ["GUEST"],
      },
    ],
  },
];

export const tempArchivedAgendas = [
  {
    inPerson: null,
    virtual: {
      zoomLink: "https://zoom.us/j/93837263648473?pwd=PWD39N82JK45LMO12",
      meetingId: "867 5309 890",
      meetingPasscode: "12345",
    },
    checkIn: {
      isEnabled: false,
      autoEnabled: true,
      minutesBefore: 15,
    },
    _id: "62d5d19e0243f51eb6a8aee9",
    meetingType: "MT",
    dates: [
      {
        startsOn: "2021-06-08T05:00:00.000Z",
        endsOn: "2022-06-08T10:00:00.000Z",
        timeZone: "America/Los_Angeles",
        _id: "63404543bfe2223dfdc3b437",
      },
      {
        startsOn: "2021-06-10T05:00:00.000Z",
        endsOn: "2022-06-10T10:00:00.000Z",
        timeZone: "America/Los_Angeles",
        _id: "63404543bfe2223dfdc3b438",
      },
    ],
    endMeeting: true,
    deliveryType: ["Virtual"],
    attendees: [
      {
        _id: "62d5c66c0243f51eb6a8ae8f",
        photoUrl:
          "https://stmanagementteamdev.blob.core.windows.net/photos/glen-baker.png",
        name: "Glen Baker",
      },
    ],
    admins: [
      {
        _id: "62ec3a0d8d12c3bc6d221792",
        name: "Doug Reichel",
        viewing: "Dashboard",
      },
    ],
    guests: [],
    agenda: [
      {
        owner: {
          _id: "62d5c66c0243f51eb6a8ae8f",
          name: "Glen Baker",
        },
        decision: {
          requiresQuorum: true,
          isBlockA: true,
          isBlockB: true,
          isMultipleChoice: false,
          choices: [
            {
              _id: "631659e1ccfbfcecb2da23c1",
              description: "YES",
              votes: [
                {
                  _id: "62d5c66c0243f51eb6a8ae8f",
                  name: "Glen Baker",
                  photoUrl:
                    "https://stmanagementteamdev.blob.core.windows.net/photos/glen-baker.png",
                  votedAs: "EC",
                  votedOn: "2022-01-01T00:00:00.000Z",
                },
              ],
            },
          ],
          status: "Off",
          displayResults: true,
        },
        file: [
          {
            type: "pdf",
            src: "3369d227-3773-49d2-b18b-b4ab097c4fe7",
          },
        ],
        publishedOn: "2021-12-01T00:00:00.000Z",
        title: "Huge Raise for Jeff Scott",
        description:
          "<ul><li>Greatest Employee Ever</li><li>Most handsome employee ever</li></ul>",
        notes: [
          {
            postedBy: {
              _id: "62ec3a0d8d12c3bc6d221791",
              name: "Bret Dickey",
            },
            _id: "62ec495d8d12c3bc6d2217a2",
            submittedOn: "2022-01-01T00:00:00.000Z",
            note: "This is an example of a quick note posted by Bret Dickey.",
          },
          {
            postedBy: {
              _id: "62ec3a0d8d12c3bc6d221792",
              name: "Doug Reichel",
            },
            _id: "62ec49b68d12c3bc6d2217a4",
            submittedOn: "2022-01-01T00:00:00.000Z",
            note: "This is an example of a quick note posted by Doug Reichel",
          },
        ],
        actionItem: {
          isCreated: true,
          assignedTo: [
            {
              _id: "62ec3a0d8d12c3bc6d221791",
              name: "Bret Dickey",
              assignedOn: "2022-01-01T00:00:00.000Z",
            },
          ],
        },
        _id: "631659b9ccfbfcecb2da23c0",
        viewedBy: [],
      },
    ],
    isDraft: true,
    isComplete: false,
    order: 1,
    version: 1,
    id: "62d5d19e0243f51eb6a8aee9",
    users: [
      {
        profile: {
          firstName: "Glen",
          lastName: "Baker",
          email: "bakerg@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/glen-baker.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Triple Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae8f",
        iboNumber: 1001139,
        contactId: 131,
        accessLevel: ["EC", "MT1"],
      },
      {
        profile: {
          firstName: "Joya",
          lastName: "Baker",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/joya-baker.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae90",
        contactId: 132,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Trevor",
          lastName: "Baker",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/trevor-baker.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae91",
        iboNumber: 1714173,
        contactId: 151656,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Lexi",
          lastName: "Baker",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/lexi-baker.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae92",
        iboNumber: 1714173,
        contactId: 506194,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Terry",
          lastName: "Brown",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/terry-brown.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae93",
        iboNumber: 801306,
        contactId: 357,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Jenny",
          lastName: "Brown",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jenny-brown.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae94",
        iboNumber: 801306,
        contactId: 358,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Ty",
          lastName: "Crandell",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/ty-crandell.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae95",
        iboNumber: 5466912,
        contactId: 1100456,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Venessa",
          lastName: "Crandell",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/venessa-crandell.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae96",
        iboNumber: 5466912,
        contactId: 1374809,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Howie",
          lastName: "Danzik",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/howie-danzik.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae97",
        iboNumber: 1857166,
        contactId: 647,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Theresa",
          lastName: "Danzik",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/theresa-danzik.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae98",
        iboNumber: 1857166,
        contactId: 648,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Brad",
          lastName: "Duncan",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/brad-duncan.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Crown Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae99",
        iboNumber: 2008212,
        contactId: 753,
        accessLevel: ["EC", "MT1"],
      },
      {
        profile: {
          firstName: "Julie",
          lastName: "Duncan",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae9a",
        iboNumber: 2008212,
        contactId: 754,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Greg",
          lastName: "Duncan",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/greg-duncan.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Triple Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae9b",
        iboNumber: 2559,
        contactId: 763,
        accessLevel: ["EC", "MT1"],
      },
      {
        profile: {
          firstName: "Laurie",
          lastName: "Duncan",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae9c",
        iboNumber: 2559,
        contactId: 764,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Tracey",
          lastName: "Eaton",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/tracey-eaton.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae9d",
        iboNumber: 855482,
        contactId: 807,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Kimberly",
          lastName: "Eaton",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae9e",
        iboNumber: 855482,
        contactId: 808,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Ryder",
          lastName: "Erickson",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/ryder-erickson.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae9f",
        iboNumber: 1754,
        contactId: 1390851,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Nicole",
          lastName: "Erickson",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aea0",
        iboNumber: 1754,
        contactId: 1467116,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Kelly",
          lastName: "Ewing",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/kelly-ewing.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aea1",
        iboNumber: 1764460,
        contactId: 873,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Darci",
          lastName: "Ewing",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aea2",
        iboNumber: 1764460,
        contactId: 874,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "David",
          lastName: "Felber",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/david-felber.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aea3",
        iboNumber: 5082,
        contactId: 895,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Jaimee",
          lastName: "Felber",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aea4",
        iboNumber: 5082,
        contactId: 896,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Hal",
          lastName: "Golden",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/hal-golden.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aea5",
        iboNumber: 1000758,
        contactId: 1091,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Ann",
          lastName: "Golden",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aea6",
        iboNumber: 1000758,
        contactId: 1092,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Scott",
          lastName: "Harimoto",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/scott-harimoto.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aea7",
        iboNumber: 1788634,
        contactId: 1211,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Cris",
          lastName: "Harimoto",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aea8",
        iboNumber: 1788634,
        contactId: 1212,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Bill",
          lastName: "Hawkins",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bill-hawkins.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aea9",
        iboNumber: 7789,
        contactId: 1247,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Sandy",
          lastName: "Hawkins",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeaa",
        iboNumber: 7789,
        contactId: 1248,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Pete",
          lastName: "Herschelman",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/pete-herschelman.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeab",
        iboNumber: 2636550,
        contactId: 232870,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Rachael",
          lastName: "Herschelman",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeac",
        iboNumber: 2636550,
        contactId: 232871,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Randy",
          lastName: "Jassman",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/randy-jassman.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aead",
        iboNumber: 1478107,
        contactId: 1463,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Raye-Lynn",
          lastName: "Jassman",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/raye-lynn-jassman.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeae",
        iboNumber: 1478107,
        contactId: 1464,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Nam-Deuk",
          lastName: "Kim",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/nam-deuk-kim.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Triple Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeaf",
        iboNumber: 3463383,
        contactId: 615827,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Jungyun",
          lastName: "Lee",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeb0",
        iboNumber: 3463383,
        contactId: 615828,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Bob",
          lastName: "Kummer",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bob-kummer.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeb1",
        iboNumber: 1002340,
        contactId: 1735,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Shelly",
          lastName: "Kummer",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeb2",
        iboNumber: 1002340,
        contactId: 1736,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Matt",
          lastName: "Nguyen",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/matt-nguyen.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeb3",
        iboNumber: 5862533,
        contactId: 1276055,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Briley",
          lastName: "Nguyen",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeb4",
        iboNumber: 5862533,
        contactId: 1393812,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Ryan",
          lastName: "Olynyk",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/ryan-olynyk.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeb5",
        iboNumber: 5652827,
        contactId: 1178425,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Noella",
          lastName: "Olynyk",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeb6",
        iboNumber: 5652827,
        contactId: 1178430,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Kevin",
          lastName: "Phillips",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/kevin-phillips.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeb7",
        iboNumber: 5248349,
        contactId: 978319,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Andrea",
          lastName: "Phillips",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeb8",
        iboNumber: 5248349,
        contactId: 978319,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Jim",
          lastName: "Puryear",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jim-puryear.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Crown Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeb9",
        iboNumber: 8252,
        contactId: 2545,
        accessLevel: ["EC", "MT1"],
      },
      {
        profile: {
          firstName: "Bobbie",
          lastName: "Puryear",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeba",
        iboNumber: 8252,
        contactId: 1504865,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Leslie",
          lastName: "Rice",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/leslie-rice.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aebb",
        iboNumber: 8690,
        contactId: 3454,
        accessLevel: ["EC", "MT1"],
      },
      {
        profile: {
          firstName: "Jeff",
          lastName: "Rice",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aebc",
        iboNumber: 8690,
        contactId: 1583325,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Jon",
          lastName: "Rosario",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jon-rosario.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aebd",
        iboNumber: 3459866,
        contactId: 384516,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Jen",
          lastName: "Rosario",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jen-rosario.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aebe",
        iboNumber: 3459866,
        contactId: 1093820,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Kenny",
          lastName: "Toms",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/kenny-toms.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aebf",
        iboNumber: 4780838,
        contactId: 782667,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Ashlea",
          lastName: "Toms",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aec0",
        iboNumber: 4780838,
        contactId: 1292635,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Matt",
          lastName: "Tsuruda",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/matt-tsuruda.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Founders Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aec1",
        iboNumber: 1003132,
        contactId: 3227,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Sandee",
          lastName: "Tsuruda",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aec2",
        iboNumber: 1003132,
        contactId: 3228,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Maiko",
          lastName: "Tuitupou",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/maiko-tuitupou.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aec3",
        iboNumber: 7611208,
        contactId: 1516598,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Kulia",
          lastName: "Tuitupou",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aec4",
        iboNumber: 7611208,
        contactId: 1516599,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Dean",
          lastName: "Whalen",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/dean-whalen.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aec5",
        iboNumber: 4633816,
        contactId: 712774,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Marcie",
          lastName: "Whalen",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aec6",
        iboNumber: 4633816,
        contactId: 730273,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Shane",
          lastName: "Yadao",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/shane-yadao.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aec7",
        iboNumber: 2612016,
        contactId: 231257,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Joey",
          lastName: "Yadao",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aec8",
        iboNumber: 2612016,
        contactId: 387811,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Mandy",
          lastName: "Yamamoto",
          email: "email@gmail.com",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aec9",
        iboNumber: 3984511,
        contactId: 477783,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Dan",
          lastName: "Yuen",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/dan-yuen.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeca",
        iboNumber: 1001870,
        contactId: 3533,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Sandy",
          lastName: "Yuen",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aecb",
        iboNumber: 1001870,
        contactId: 3534,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Bret",
          lastName: "Dickey",
          email: "mbd@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221791",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Doug",
          lastName: "Reichel",
          email: "ddr@wwdb.com",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221792",
        accessLevel: ["MANAGER"],
      },
      {
        profile: {
          firstName: "Kelly",
          lastName: "Moorman",
          email: "krm@wwdb.com",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221793",
        accessLevel: ["MANAGER"],
      },
      {
        profile: {
          firstName: "Britt",
          lastName: "Scott",
          email: "bls@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/britt-scott.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221794",
        accessLevel: ["MANAGER"],
      },
      {
        profile: {
          firstName: "Jeff",
          lastName: "Scott",
          email: "jcs@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jeff-scott.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221795",
        accessLevel: ["MANAGER"],
      },
      {
        profile: {
          firstName: "Miguel",
          lastName: "Rangel",
          email: "mpr@wwdb.com",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221796",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Katelynn",
          lastName: "West",
          email: "krwest@wwdb.com",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221797",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Adam",
          lastName: "Overfelt",
          email: "ajo@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/adam-overfelt.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990cd",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Andy",
          lastName: "Wickwire",
          email: "adw@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/andy-Wickwire.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990ce",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Eliana",
          lastName: "Osburn",
          email: "emo@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/eliana-osburn.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990cf",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Eve",
          lastName: "Bratrud",
          email: "emb@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/eve-bratrud.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990d0",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Jen",
          lastName: "Howe",
          email: "jlh@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jen-howe.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990d1",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Kevin",
          lastName: "Shay",
          email: "krs@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/kevin-shay.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990d2",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Vince",
          lastName: "Peasley",
          email: "vep@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/vince-peasley.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990d3",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Yajaira",
          lastName: "Elvira",
          email: "yae@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/yajaira-elvira.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990d4",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Matt",
          lastName: "Baker",
          email: "MattB@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "632a3a3b97da849d696044ae",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "User",
          lastName: "One",
          email: "ttp@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "632a5dd797da849d696044af",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Patrick",
          lastName: "Li",
          email: "PLi@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "632bcd250922192bf1db9ad6",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Tristan",
          lastName: "Johnson",
          email: "TristanJ@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "63351bee84c8303429b38095",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Tristan",
          lastName: "Johnson",
          email: "tristanj@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "63351c1f84c8303429b38096",
        accessLevel: ["GUEST"],
      },
    ],
  },
  {
    inPerson: null,
    virtual: {
      zoomLink: "https://zoom.us/j/93837263648473?pwd=PWD39N82JK45LMO12",
      meetingId: "867 5309 890",
      meetingPasscode: "12345",
    },
    checkIn: {
      isEnabled: false,
      autoEnabled: true,
      minutesBefore: 15,
    },
    _id: "62d5d19e0243f51eb6a8aee9",
    meetingType: "MT",
    dates: [
      {
        startsOn: "2020-06-08T05:00:00.000Z",
        endsOn: "2020-06-08T10:00:00.000Z",
        timeZone: "America/Los_Angeles",
        _id: "63404543bfe2223dfdc3b437",
      },
      {
        startsOn: "2022-06-10T05:00:00.000Z",
        endsOn: "2022-06-10T10:00:00.000Z",
        timeZone: "America/Los_Angeles",
        _id: "63404543bfe2223dfdc3b438",
      },
    ],
    endMeeting: true,
    deliveryType: ["Virtual"],
    attendees: [
      {
        _id: "62d5c66c0243f51eb6a8ae8f",
        photoUrl:
          "https://stmanagementteamdev.blob.core.windows.net/photos/glen-baker.png",
        name: "Glen Baker",
      },
    ],
    admins: [
      {
        _id: "62ec3a0d8d12c3bc6d221792",
        name: "Doug Reichel",
        viewing: "Dashboard",
      },
    ],
    guests: [],
    agenda: [
      {
        owner: {
          _id: "62d5c66c0243f51eb6a8ae8f",
          name: "Glen Baker",
        },
        decision: {
          requiresQuorum: true,
          isBlockA: true,
          isBlockB: true,
          isMultipleChoice: false,
          choices: [
            {
              _id: "631659e1ccfbfcecb2da23c1",
              description: "YES",
              votes: [
                {
                  _id: "62d5c66c0243f51eb6a8ae8f",
                  name: "Glen Baker",
                  photoUrl:
                    "https://stmanagementteamdev.blob.core.windows.net/photos/glen-baker.png",
                  votedAs: "EC",
                  votedOn: "2022-01-01T00:00:00.000Z",
                },
              ],
            },
          ],
          status: "Off",
          displayResults: true,
        },
        file: [
          {
            type: "pdf",
            src: "3369d227-3773-49d2-b18b-b4ab097c4fe7",
          },
        ],
        publishedOn: "2021-12-01T00:00:00.000Z",
        title: "Huge Raise for Jeff Scott",
        description:
          "<ul><li>Greatest Employee Ever</li><li>Most handsome employee ever</li></ul>",
        notes: [
          {
            postedBy: {
              _id: "62ec3a0d8d12c3bc6d221791",
              name: "Bret Dickey",
            },
            _id: "62ec495d8d12c3bc6d2217a2",
            submittedOn: "2022-01-01T00:00:00.000Z",
            note: "This is an example of a quick note posted by Bret Dickey.",
          },
          {
            postedBy: {
              _id: "62ec3a0d8d12c3bc6d221792",
              name: "Doug Reichel",
            },
            _id: "62ec49b68d12c3bc6d2217a4",
            submittedOn: "2022-01-01T00:00:00.000Z",
            note: "This is an example of a quick note posted by Doug Reichel",
          },
        ],
        actionItem: {
          isCreated: true,
          assignedTo: [
            {
              _id: "62ec3a0d8d12c3bc6d221791",
              name: "Bret Dickey",
              assignedOn: "2022-01-01T00:00:00.000Z",
            },
          ],
        },
        _id: "631659b9ccfbfcecb2da23c0",
        viewedBy: [],
      },
    ],
    isDraft: true,
    isComplete: false,
    order: 1,
    version: 1,
    id: "62d5d19e0243f51eb6a8aee9",
    users: [
      {
        profile: {
          firstName: "Glen",
          lastName: "Baker",
          email: "bakerg@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/glen-baker.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Triple Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae8f",
        iboNumber: 1001139,
        contactId: 131,
        accessLevel: ["EC", "MT1"],
      },
      {
        profile: {
          firstName: "Joya",
          lastName: "Baker",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/joya-baker.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae90",
        contactId: 132,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Trevor",
          lastName: "Baker",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/trevor-baker.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae91",
        iboNumber: 1714173,
        contactId: 151656,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Lexi",
          lastName: "Baker",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/lexi-baker.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae92",
        iboNumber: 1714173,
        contactId: 506194,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Terry",
          lastName: "Brown",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/terry-brown.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae93",
        iboNumber: 801306,
        contactId: 357,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Jenny",
          lastName: "Brown",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jenny-brown.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae94",
        iboNumber: 801306,
        contactId: 358,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Ty",
          lastName: "Crandell",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/ty-crandell.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae95",
        iboNumber: 5466912,
        contactId: 1100456,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Venessa",
          lastName: "Crandell",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/venessa-crandell.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae96",
        iboNumber: 5466912,
        contactId: 1374809,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Howie",
          lastName: "Danzik",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/howie-danzik.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae97",
        iboNumber: 1857166,
        contactId: 647,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Theresa",
          lastName: "Danzik",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/theresa-danzik.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae98",
        iboNumber: 1857166,
        contactId: 648,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Brad",
          lastName: "Duncan",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/brad-duncan.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Crown Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae99",
        iboNumber: 2008212,
        contactId: 753,
        accessLevel: ["EC", "MT1"],
      },
      {
        profile: {
          firstName: "Julie",
          lastName: "Duncan",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae9a",
        iboNumber: 2008212,
        contactId: 754,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Greg",
          lastName: "Duncan",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/greg-duncan.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Triple Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae9b",
        iboNumber: 2559,
        contactId: 763,
        accessLevel: ["EC", "MT1"],
      },
      {
        profile: {
          firstName: "Laurie",
          lastName: "Duncan",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae9c",
        iboNumber: 2559,
        contactId: 764,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Tracey",
          lastName: "Eaton",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/tracey-eaton.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae9d",
        iboNumber: 855482,
        contactId: 807,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Kimberly",
          lastName: "Eaton",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8ae9e",
        iboNumber: 855482,
        contactId: 808,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Ryder",
          lastName: "Erickson",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/ryder-erickson.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8ae9f",
        iboNumber: 1754,
        contactId: 1390851,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Nicole",
          lastName: "Erickson",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aea0",
        iboNumber: 1754,
        contactId: 1467116,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Kelly",
          lastName: "Ewing",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/kelly-ewing.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aea1",
        iboNumber: 1764460,
        contactId: 873,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Darci",
          lastName: "Ewing",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aea2",
        iboNumber: 1764460,
        contactId: 874,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "David",
          lastName: "Felber",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/david-felber.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aea3",
        iboNumber: 5082,
        contactId: 895,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Jaimee",
          lastName: "Felber",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aea4",
        iboNumber: 5082,
        contactId: 896,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Hal",
          lastName: "Golden",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/hal-golden.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aea5",
        iboNumber: 1000758,
        contactId: 1091,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Ann",
          lastName: "Golden",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aea6",
        iboNumber: 1000758,
        contactId: 1092,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Scott",
          lastName: "Harimoto",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/scott-harimoto.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aea7",
        iboNumber: 1788634,
        contactId: 1211,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Cris",
          lastName: "Harimoto",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aea8",
        iboNumber: 1788634,
        contactId: 1212,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Bill",
          lastName: "Hawkins",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bill-hawkins.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aea9",
        iboNumber: 7789,
        contactId: 1247,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Sandy",
          lastName: "Hawkins",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeaa",
        iboNumber: 7789,
        contactId: 1248,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Pete",
          lastName: "Herschelman",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/pete-herschelman.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeab",
        iboNumber: 2636550,
        contactId: 232870,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Rachael",
          lastName: "Herschelman",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeac",
        iboNumber: 2636550,
        contactId: 232871,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Randy",
          lastName: "Jassman",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/randy-jassman.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aead",
        iboNumber: 1478107,
        contactId: 1463,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Raye-Lynn",
          lastName: "Jassman",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/raye-lynn-jassman.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeae",
        iboNumber: 1478107,
        contactId: 1464,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Nam-Deuk",
          lastName: "Kim",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/nam-deuk-kim.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Triple Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeaf",
        iboNumber: 3463383,
        contactId: 615827,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Jungyun",
          lastName: "Lee",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeb0",
        iboNumber: 3463383,
        contactId: 615828,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Bob",
          lastName: "Kummer",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bob-kummer.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeb1",
        iboNumber: 1002340,
        contactId: 1735,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Shelly",
          lastName: "Kummer",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeb2",
        iboNumber: 1002340,
        contactId: 1736,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Matt",
          lastName: "Nguyen",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/matt-nguyen.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeb3",
        iboNumber: 5862533,
        contactId: 1276055,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Briley",
          lastName: "Nguyen",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeb4",
        iboNumber: 5862533,
        contactId: 1393812,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Ryan",
          lastName: "Olynyk",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/ryan-olynyk.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeb5",
        iboNumber: 5652827,
        contactId: 1178425,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Noella",
          lastName: "Olynyk",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeb6",
        iboNumber: 5652827,
        contactId: 1178430,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Kevin",
          lastName: "Phillips",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/kevin-phillips.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeb7",
        iboNumber: 5248349,
        contactId: 978319,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Andrea",
          lastName: "Phillips",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeb8",
        iboNumber: 5248349,
        contactId: 978319,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Jim",
          lastName: "Puryear",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jim-puryear.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Crown Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeb9",
        iboNumber: 8252,
        contactId: 2545,
        accessLevel: ["EC", "MT1"],
      },
      {
        profile: {
          firstName: "Bobbie",
          lastName: "Puryear",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aeba",
        iboNumber: 8252,
        contactId: 1504865,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Leslie",
          lastName: "Rice",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/leslie-rice.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aebb",
        iboNumber: 8690,
        contactId: 3454,
        accessLevel: ["EC", "MT1"],
      },
      {
        profile: {
          firstName: "Jeff",
          lastName: "Rice",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aebc",
        iboNumber: 8690,
        contactId: 1583325,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Jon",
          lastName: "Rosario",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jon-rosario.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aebd",
        iboNumber: 3459866,
        contactId: 384516,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Jen",
          lastName: "Rosario",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jen-rosario.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aebe",
        iboNumber: 3459866,
        contactId: 1093820,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Kenny",
          lastName: "Toms",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/kenny-toms.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aebf",
        iboNumber: 4780838,
        contactId: 782667,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Ashlea",
          lastName: "Toms",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aec0",
        iboNumber: 4780838,
        contactId: 1292635,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Matt",
          lastName: "Tsuruda",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/matt-tsuruda.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Founders Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aec1",
        iboNumber: 1003132,
        contactId: 3227,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Sandee",
          lastName: "Tsuruda",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aec2",
        iboNumber: 1003132,
        contactId: 3228,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Maiko",
          lastName: "Tuitupou",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/maiko-tuitupou.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aec3",
        iboNumber: 7611208,
        contactId: 1516598,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Kulia",
          lastName: "Tuitupou",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aec4",
        iboNumber: 7611208,
        contactId: 1516599,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Dean",
          lastName: "Whalen",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/dean-whalen.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Double Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aec5",
        iboNumber: 4633816,
        contactId: 712774,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Marcie",
          lastName: "Whalen",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aec6",
        iboNumber: 4633816,
        contactId: 730273,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Shane",
          lastName: "Yadao",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/shane-yadao.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aec7",
        iboNumber: 2612016,
        contactId: 231257,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Joey",
          lastName: "Yadao",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aec8",
        iboNumber: 2612016,
        contactId: 387811,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Mandy",
          lastName: "Yamamoto",
          email: "email@gmail.com",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Executive Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aec9",
        iboNumber: 3984511,
        contactId: 477783,
        accessLevel: ["MT2"],
      },
      {
        profile: {
          firstName: "Dan",
          lastName: "Yuen",
          email: "email@gmail.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/dan-yuen.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [
            {
              year: 2020,
              garPoints: 47,
              integratedGarPoints: 0,
              diamondRankGar: 2,
              diamondRankWWG: 4,
              pinWearing: "Diamond",
              isExecutiveCommittee: true,
              isVotingMember: true,
              capitalShare: 28.24,
              yearVotingMemberQualified: 1997,
            },
          ],
        },
        _id: "62d5c66c0243f51eb6a8aeca",
        iboNumber: 1001870,
        contactId: 3533,
        accessLevel: ["MT1"],
      },
      {
        profile: {
          firstName: "Sandy",
          lastName: "Yuen",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62d5c66c0243f51eb6a8aecb",
        iboNumber: 1001870,
        contactId: 3534,
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Bret",
          lastName: "Dickey",
          email: "mbd@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221791",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Doug",
          lastName: "Reichel",
          email: "ddr@wwdb.com",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221792",
        accessLevel: ["MANAGER"],
      },
      {
        profile: {
          firstName: "Kelly",
          lastName: "Moorman",
          email: "krm@wwdb.com",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221793",
        accessLevel: ["MANAGER"],
      },
      {
        profile: {
          firstName: "Britt",
          lastName: "Scott",
          email: "bls@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/britt-scott.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221794",
        accessLevel: ["MANAGER"],
      },
      {
        profile: {
          firstName: "Jeff",
          lastName: "Scott",
          email: "jcs@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jeff-scott.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221795",
        accessLevel: ["MANAGER"],
      },
      {
        profile: {
          firstName: "Miguel",
          lastName: "Rangel",
          email: "mpr@wwdb.com",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221796",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Katelynn",
          lastName: "West",
          email: "krwest@wwdb.com",
          photoUrl: "",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62ec3a0d8d12c3bc6d221797",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Adam",
          lastName: "Overfelt",
          email: "ajo@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/adam-overfelt.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990cd",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Andy",
          lastName: "Wickwire",
          email: "adw@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/andy-Wickwire.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990ce",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Eliana",
          lastName: "Osburn",
          email: "emo@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/eliana-osburn.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990cf",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Eve",
          lastName: "Bratrud",
          email: "emb@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/eve-bratrud.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990d0",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Jen",
          lastName: "Howe",
          email: "jlh@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/jen-howe.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990d1",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Kevin",
          lastName: "Shay",
          email: "krs@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/kevin-shay.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990d2",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Vince",
          lastName: "Peasley",
          email: "vep@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/vince-peasley.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990d3",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Yajaira",
          lastName: "Elvira",
          email: "yae@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/yajaira-elvira.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "62f6ca8f6002277c6f7990d4",
        accessLevel: [],
      },
      {
        profile: {
          firstName: "Matt",
          lastName: "Baker",
          email: "MattB@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "632a3a3b97da849d696044ae",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "User",
          lastName: "One",
          email: "ttp@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "632a5dd797da849d696044af",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Patrick",
          lastName: "Li",
          email: "PLi@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "632bcd250922192bf1db9ad6",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Tristan",
          lastName: "Johnson",
          email: "TristanJ@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "63351bee84c8303429b38095",
        accessLevel: ["GUEST"],
      },
      {
        profile: {
          firstName: "Tristan",
          lastName: "Johnson",
          email: "tristanj@wwdb.com",
          photoUrl:
            "https://stmanagementteamdev.blob.core.windows.net/photos/bret-dickey.png",
        },
        businessInfo: {
          qualifyingRequirementsByYear: [],
        },
        _id: "63351c1f84c8303429b38096",
        accessLevel: ["GUEST"],
      },
    ],
  },
];
